/** Internal vertical catalog (shared across ADW, Roots, and future networks). */

export interface VerticalOption {
  slug: string
  name: string
}

export const VERTICAL_PRESETS: readonly VerticalOption[] = [
  { slug: "depression-test", name: "Depression Test" },
  { slug: "mental-test", name: "Mental Test" },
  { slug: "soulmate", name: "Soulmate" },
  { slug: "love-calculator", name: "Love Calculator" },
  { slug: "anxiety-test", name: "Anxiety Test" },
  { slug: "ai-tools", name: "AI Tools" },
  { slug: "bmi-calculator", name: "BMI Calculator" },
] as const

export function slugifyVerticalName(raw: string): string {
  const s = raw.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/_+/g, "_")
  return s.replace(/^_|_$/g, "") || "vertical"
}

export function defaultVerticalDisplayName(slug: string): string {
  const t = slug.trim()
  if (!t) return ""
  return t
    .split(/[-_]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ")
}
